var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ss-button text-nowrap",class:((this.$store.state.brand.name) + " " + (this.flavor)),on:{"click":function($event){return _vm.CtaAction()}}},[_vm._v(_vm._s(_vm.brandButtonText))])}
var staticRenderFns = []

export { render, staticRenderFns }